import * as React from 'react'

import { Label, RadioDot, RadioView, Wrapper } from './Radio.styles'

interface Props extends React.InputHTMLAttributes<any> {
  label: string
  value: string
  name?: string
  checked: boolean
  onChange?: (event: React.ChangeEvent<any>) => void
}

export const RadioField: React.SFC<Props> = ({
  name,
  label,
  value,
  checked,
  onChange,
}) => {
  return (
    <Wrapper>
      <RadioDot checked={checked} />
      <RadioView
        type="radio"
        id={value}
        value={value}
        name={name}
        defaultChecked={checked}
        onChange={onChange}
      />

      <Label as="span" size="s" color={checked ? 'black' : 'gray'}>
        {label}
      </Label>
    </Wrapper>
  )
}

export default RadioField
